import { styledComponent } from '@hermes/web-components'

export const Container = styledComponent('div')`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: center;
`

export const AreasItemsContainer = styledComponent('div')`
  display: flex;
  gap: 43px;
  align-items: center;
  justify-content: center;
  `

export const MobileAreasItemsContainer = styledComponent('div')`
  display: flex;
  gap: 16px;
  flex-direction: column;
  `

export const MobileContainer = styledComponent('div')`
  display: flex;
  gap: 32px;
  `

export const MainText = styledComponent('h2')`
  color: #11245A;
  font-weight: 500;
  font-size: 18px;
  margin: 0;
  `
